import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

import './normalize.css'
import './bootstrap5.css'
import './quoter.css'
import './toast.css'
import './tailwindcss.css'

let intervalId
intervalId = setInterval(() => {
    console.log('checking #app...')
    const root = document.getElementById('app')
    if (root) {
        console.log('app found!')
        ReactDOM.createRoot(root).render(<App />)
        clearInterval(intervalId)
    }
    else {
        console.log('app not found!')
    }
}, 500)
